module.exports = __webpack_public_path__ + "img/bg-ha.9bcc672c.jpg";